import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const PrivateRoutes = () => {
  const { userAuth } = useSelector((state) => state.userAuth);
  const location = useLocation();
  // Not logged in: remember where they were going (e.g. the job or the
  // provider agreement from a text message) so login brings them back there.
  if (!userAuth) {
    try { sessionStorage.setItem("dra_after_login", location.pathname + location.search); } catch (e) { /* storage blocked */ }
    return <Navigate to="/" />;
  }
  return <Outlet />;
};